import Masthead from "./components/Masthead";
import CoverSection from "./components/CoverSection";
import CollapseField from "./components/CollapseField";
import ReversalField from "./components/ReversalField";
import AvoidListSection from "./components/AvoidListSection";
import HeatRank from "./components/HeatRank";
import WatchSection from "./components/WatchSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Masthead />
      <main className="pt-[116px] md:pt-[120px]">
        <CoverSection />
        <CollapseField />
        <ReversalField />
        <AvoidListSection />
        <HeatRank />
        <WatchSection />
      </main>
      <Footer />
    </div>
  );
}